import { createAction, props } from "@ngrx/store";
import { CirculationId } from "src/app/interfaces";

const actionTypePrefix = "[Circulation/Document]";

export const uploadDocumentStarted = createAction(
  `${actionTypePrefix} Upload document started`
);

export const uploadDocumentFailed = createAction(
  `${actionTypePrefix} Upload document failed`
);

export const uploadDocumentCompleted = createAction(
  `${actionTypePrefix} Upload document completed`
);

export const removeDocument = createAction(
  `${actionTypePrefix} Remove document from circulation`,
  props<{ id: CirculationId; docId: string }>()
);

export const removeDocumentFailed = createAction(
  `${actionTypePrefix} Remove document from circulation failed`,
  props<{ id: CirculationId; docId: string; error: string }>()
);

export const removeDocumentSuccess = createAction(
  `${actionTypePrefix} Remove document from circulation completed`,
  props<{ id: CirculationId; docId: string }>()
);
